<template>
    <div class="image-preview tw-relative" @click="removeImage(index)">
        <img class="new-post-image-preview" :src="preview">
        <div class="upload-progress tw-absolute tw-left-0 tw-right-0 tw-mx-auto tw-z-10 tw-rounded tw-overflow-hidden tw-bg-gray-800 tw-shadow-deep" v-if="uploading">
            <div class="tw-bg-white tw-h-full"></div>
        </div>
        <div class="finish-animation" v-if="upload_complete_animation">
            <i class="fa fa-check"></i>
        </div>
    </div>
</template>

<script>
    import ImageUploader from '../../mixins/ImageUploader.js'

    export default {
        mixins: [ImageUploader]
    }
</script>